<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md flex flex-col w-full relative">
        <form [formGroup]="pageForm" (ngSubmit)="submit()">
            <h1 class="font-bold text-xl">{{title}}</h1>
            <p class="text-primary-300 text-sm">{{description}}</p>
            <div class="w-full mt-4 mb-1">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="gradeName">Grade Name
                    *</label>
                <input type="text" name="gradeName" id="gradeName" formControlName="gradeName" placeholder="Grade Name"
                    required class="rounded w-full text-sm my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                <div
                    class="{{ pageForm.get('gradeName')?.invalid && (pageForm.get('gradeName')?.dirty || pageForm.get('gradeName')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                    @if (pageForm.get('gradeName')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    } @else if(pageForm.get('gradeName')?.errors?.['minlength'] ||
                    pageForm.get('gradeName')?.errors?.['maxlength']) {
                    <p>
                        Min 10 and max 50 characters required
                    </p>
                    }
                </div>
            </div>
            <div class="w-full mb-1">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="gradeName">Average Student
                    Age *</label>
                <input type="number" name="gradeAvgAge" id="gradeAvgAge" formControlName="gradeAvgAge"
                    placeholder="Age Number" required
                    class="rounded w-full text-sm my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                <div
                    class="{{ pageForm.get('gradeAvgAge')?.invalid && (pageForm.get('gradeAvgAge')?.dirty || pageForm.get('gradeAvgAge')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                    @if (pageForm.get('gradeAvgAge')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    }
                </div>
            </div>
            <!-- <div class="w-full">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1" for="teacherId">Assign
                    Teacher</label>
                <select name="teacherId" id="teacherId" formControlName="teacherId"
                    class="px-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                    @for (item of faculty; track item.memberId) {
                    <option [selected]="pageForm.get('teacherId')?.value == item.memberId" [value]="item.memberId">
                        <div class="flex-1 inline-flex flex-span text-sm text-blueGray-600">
                            <span>{{item.name}}</span>
                        </div>
                    </option>
                    }
                    <option [selected]="pageForm.get('teacherId')?.value == 'unassigned'" value="unassigned"
                        class="text-sm">Unassigned
                    </option>
                </select>
            </div> -->
            <div class="flex flex-row gap-4 justify-end mt-4">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <button type="submit" [disabled]="pageForm.invalid"
                    class="bg-primary-500 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button>
            </div>
        </form>
    </div>
</div>